// extracted by mini-css-extract-plugin
module.exports = {"container":"scrollZone_container__sQnNn","bottom":"scrollZone_bottom__nwYD0","isDragging":"scrollZone_isDragging__N_utS"};